import React from "react";
import FemaleSexIcon from "../../../../assets/icons/female_sex_icon.svg";
import MaleSexIcon from "../../../../assets/icons/male_sex_icon.svg";
import UnsureSexIcon from "../../../../assets/icons/unsure_sex_icon.svg";
import SpeciesIcon from "../../../../assets/icons/darkerSP.svg";
import DNAIcon from "../../../../assets/icons/twemoji_dna.svg";
import { getSppDisplayName } from "../../../../utils/caseConvert";
import OpacityIcon from "@mui/icons-material/Opacity";
import { Typography, Box } from "@mui/material";
import LoopIcon from "@mui/icons-material/Loop";

const imgSize = [1, 1, 1, 1, 1, 1];
const imgGap = [0.15, 0.15, 0.15, 0.15, 0.2, 0.2];
const IMAGE_SX = {
  width: imgSize.map((size) => `${size}rem`),
  height: imgSize.map((size) => `${size}rem`),
};

const getTopY = (i) =>
  imgSize.map((size, index) => `${i * (size + imgGap[index])}rem`);

const SpecimenBBox = ({ s, i, w, h, topX, topY, border, handleJump }) => {
  return (
    <div
      key={`bbox${i}`}
      style={{
        position: "absolute",
        border: border,
        height: h,
        width: w,
        top: topY,
        left: topX,
        overflow: "hidden",
        padding: 5,
        minWidth: 0,
      }}
      className={
        "flex flex-col justify-between hover:bg-blue-400 hover:bg-opacity-25"
      }
      onClick={handleJump}
      data-testid="bounding-box"
    >
      <Box
        className={"flex flex-col justify-between"}
        sx={{
          "& img": IMAGE_SX,
          "& svg": IMAGE_SX,
        }}
      >
        <Box
          sx={{
            position: "absolute",
            right: 0,
            visibility: s?.humanId?.genus ? "visible" : "hidden",
          }}
        >
          <img
            className={"w-6"}
            style={{
              color: "#167bc3",
            }}
            src={SpeciesIcon}
            alt=""
            title="Species Icon"
          ></img>
        </Box>
        <Box
          className={"contegenusnt-center"}
          sx={{
            position: "absolute",
            right: 0,
            top: getTopY(1),
            mt: [
              "0.25rem",
              "0.25rem",
              "0.25rem",
              "0.25rem",
              "0.5rem",
              "0.5rem",
            ],
            visibility: s?.humanId?.sex ? "visible" : "hidden",
          }}
        >
          <img
            className={"w-4 mx-auto"}
            src={
              s?.humanId?.sex === "male"
                ? MaleSexIcon
                : s?.humanId?.sex === "female"
                ? FemaleSexIcon
                : UnsureSexIcon
            }
            alt=""
            title={
              s?.humanId?.sex === "male"
                ? "Male Sex Icon"
                : s?.humanId?.sex === "female"
                ? "Female Sex Icon"
                : "Unsure Sex Icon"
            }
          ></img>
        </Box>
        <Box
          sx={{
            position: "absolute",
            right: 0,
            top: getTopY(2),
            mt: [
              "0.25rem",
              "0.25rem",
              "0.25rem",
              "0.25rem",
              "0.5rem",
              "0.5rem",
            ],
            visibility: s?.molecularId?.well ? "visible" : "hidden",
          }}
        >
          <img className={"w-6"} src={DNAIcon} alt="" title="DNA Icon"></img>
        </Box>
        <Box
          sx={{
            position: "absolute",
            right: 0,
            top: getTopY(3),
            visibility: s?.humanId?.gonotrophic ? "visible" : "hidden",
            mt: [
              "0.25rem",
              "0.25rem",
              "0.25rem",
              "0.25rem",
              "0.5rem",
              "0.5rem",
            ],
          }}
        >
          <OpacityIcon sx={{ color: "rgb(255,0,0,0.7)" }} />
        </Box>
        <Box
          sx={{
            position: "absolute",
            right: 0,
            top: getTopY(4),
            mt: [
              "0.25rem",
              "0.25rem",
              "0.25rem",
              "0.25rem",
              "0.5rem",
              "0.5rem",
            ],
            visibility: s?.humanId?.lifeStage ? "visible" : "hidden",
          }}
        >
          <LoopIcon sx={{ color: "rgb(26, 93, 26)" }} />
        </Box>
      </Box>

      <span
        className={
          "truncate font-semibold text-blue-700 text-center italic hover:opacity-100 z-10"
        }
      >
        <Typography
          sx={{
            fontSize: [
              "0.86rem", // Increase size for specimen labels in tray
              "0.86rem",
              "0.86rem",
              "0.86rem",
              "1.2rem",
              "1.2rem",
            ],
          }}
        >
          {s?.humanId?.genus && s.humanId?.species
            ? getSppDisplayName(s?.humanId?.genus, s.humanId?.species, 2)
            : (s?.bboxGenus || s?.bboxGenus === "") &&
              (s?.bboxSpecies || s?.bboxSpecies === "")
            ? getSppDisplayName(s.bboxGenus, s.bboxSpecies, 2)
            : null}
        </Typography>
      </span>
    </div>
  );
};

export default SpecimenBBox;
